import { NewsCategorySideInput, NormalSideInput } from "../../components"
import { useOutletContext } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import { axiosReq } from "../../commons/axiosReq";
import Pen from "../../assets/icon/NewsIcons/MainAdmin/NewsPenSmallWhite";

const MainAdminTagsCategoryAdd = () => {
    
      const [selectedOptions, setSelectedOptions] = useState([]);
      const [snipper, setSnipper] = useState(false);
      const [showErrorModalStep1,
        setShowErrorModalStep1] = useState(false);
      const [approvalRequired, setApprovalRequired] = useState("yes"); // حالت پیش‌فرض: "دارد"
      const [error, setError] = useState();
      const [setRecheck,reCheck,cats,allValues,setAllValues,edit] = useOutletContext();
      console.log(allValues)
      //  useEffect(() => {
      //   console.log(999)
      //   console.log(cats)
      //   setAllValues({     CategoryName:cats?cats?.categoryName: '',
      //     Color:cats?cats?.color: '',
      //     Descreption: cats?cats?.descreption:'', })
      // }, [cats]);
    
      // const [allValues, setAllValues] = useState({
      //   CategoryName:cats?cats?.categoryName: '',
      //   Color:cats?cats?.color: '',
      //   Descreption: cats?cats?.descreption:'',
    
      // });
      const [allValuesError, setAllValuesError] = useState({
        Tag: false,
        
    
      });
    
    
      const blurHandler = e => {
        if (e.target) {
          if (e.target.value == "") {
    
            setAllValuesError({ ...allValuesError, [e.target.name]: true })
          }
    
    
        }
    
      }
    
      const changeHandler = e => {
        if (e.target) {
          if (e.target.value != "") {
    
            setAllValuesError({ ...allValuesError, [e.target.name]: false })
          }
          else {
            setAllValuesError({ ...allValuesError, [e.target.name]: true })
    
          }
          // setAllValuesError({ ...allValuesError, [""]: false })
    
    
          setAllValues({ ...allValues, [e.target.name]: e.target.value })
        }
      }
      const handleKeyDown = (e) => {
        if (e.code === "Enter") {
          addCategory();
        }
      };
      const handleSelectChange = (selected) => {
        setSelectedOptions(selected || []);
      };
      const handleRadioChange = (e) => {
        setAllValues({ ...allValues, [e.target.name]: e.target.value })
    
      };
    
      const addCategory = async () => {
    
        setSnipper(true)
        var res = allFull(allValues)
        console.log(res)
    
    
        if (res) {
    
          const dataUser = await axiosReq("Article/CreateTag", "post", {
            tag: allValues?.Tag,
            
          });
          console.log(dataUser)
          if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            setRecheck(!reCheck)
    
            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
            alert("موفقیت آمیز");
          }
          else {
            console.log(allValuesError)
            console.log(dataUser)
            setError(dataUser)
    
            setShowErrorModalStep1(true);
          }
        }
        else {
          console.log(allValuesError)
          setShowErrorModalStep1(true);
    
    
        }
      }
      const editCategory = async () => {
    
        setSnipper(true)
        var res = allFull(allValues)
        // console.log(res)
    
    
        if (res) {
    
          const dataUser = await axiosReq("Article/UpdateTag", "put", {
            TagId: allValues?.CategoryId,
            Tag: allValues?.CategoryName,
    
          });
          console.log(dataUser)
          if (dataUser?.status == 200 || dataUser?.status == 204 || dataUser?.status == 201) {
            setRecheck(!reCheck)
            setAllValues({ Tag: "",
            })
            //   navigate("/newRequestStep2/" + dataUser?.data?.requestId)
            alert("موفقیت آمیز");
          }
          else {
            console.log(allValuesError)
            console.log(dataUser)
            setError(dataUser)
    
            setShowErrorModalStep1(true);
          }
        }
        else {
          console.log(allValuesError)
          setShowErrorModalStep1(true);
    
    
        }
      }
    
      const allFull = (obj) => {
        const updatedState = {};
        var result = true;
        for (var o in obj) {
          if (obj[o] == "" && o != "Edit" && o != "categoryId" && o != "categoryDescription" && o != "categoryColor" ) {
            updatedState[o] = true;
            console.log(o)
    
            setAllValuesError({ ...allValuesError, ...updatedState })
            result = false;
          }
          // else if(obj[o] == "" && o=="SubCategoryId" && obj["CategoryId"] != ""){
          //     updatedState[o] = true;
    
    
          //     setAllValuesError({ ...allValuesError, ...updatedState })
          //     result = false;
          // }
    
        }
        console.log(allValuesError)
        return result
      }
      const customStyles = {
        control: (provided, state) => ({
          ...provided,
          borderColor: state.isFocused ? "#f1f5ff" : "#f1f5ff",
          borderRadius: 5, // رنگ بوردر در حالت فوکوس و غیرفوکوس
          "&:hover": {
            borderColor: "#f1f5ff", // رنگ بوردر هنگام هاور
          },
          boxShadow: state.isFocused ? "none" : "none", // سایه در حالت فوکوس
        }),
        multiValue: (provided) => ({
          ...provided,
          backgroundColor: "#e8eeff", // رنگ پس‌زمینه تگ‌های انتخاب شده
          color: "#fff",
        }),
        multiValueLabel: (provided) => ({
          ...provided,
          color: "#000", // رنگ متن تگ‌های انتخاب شده
        }),
        multiValueRemove: (provided) => ({
          ...provided,
          color: "#000",
          "&:hover": {
            backgroundColor: "#E64A19", // رنگ پس‌زمینه دکمه حذف هنگام هاور
            color: "white",
          },
        }),
      };
      const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
          object.target.value = object.target.value.slice(0, object.target.maxLength)
        }
      }

    return(
        <div className="rounded-[15px] pt-[15px] px-[15px] pb-[70px] border-borderGray border-2">
            <p className="text-[15px] font-IRANYekanExtra text-mainColor2">افزودن برچسب تازه</p>
            <div className="my-[22px]"><div className="mb-[12px]">
        <NormalSideInput
          onBlur={blurHandler}
          name="Tag"
          onChange={changeHandler}
          value={allValues?.Tag}
          onInput={maxLengthCheck}
          maxLength={100}
          title={"نام برچسب "}
          placeHolder={"نام برچسب "} /></div></div>

<div className="flex justify-center items-center">


    { allValues?.Edit == true ?
    <button onClick={() => editCategory()} className="w-[170px] h-[40px] bg-mainGreen shadow-norm-shadow rounded-[10px] mt-2 flex justify-center items-center ">
    <div className="mt-[2px]"><Pen /></div>
    <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">ویرایش برچسب</p>
    </button>
    :
    <button onClick={() => addCategory()} className="w-[170px] h-[40px] bg-infinity-gradient shadow-norm-shadow rounded-[10px] mt-2 flex justify-center items-center ">
      <p className="font-IRANYekanLight text-[28px] text-white">+</p>
      <p className="font-IRANYekanBold text-[14px] text-white mr-[7px]">افزودن  برچسب</p>
    </button>
    }

</div>


       
        </div>
        
    )
}

export default MainAdminTagsCategoryAdd;